import { useEffect, useState } from 'react';
import styles from './Toast.module.css';

interface ToastProps {
  message: string;
  duration?: number;
  onClose: () => void;
}

/**
 * 悬浮提示，自动消失
 */
export const Toast: React.FC<ToastProps> = ({ message, duration = 2500, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // 触发入场动画
    requestAnimationFrame(() => setVisible(true));

    const timer = setTimeout(() => {
      setVisible(false);
    }, duration);
    return () => clearTimeout(timer);
  }, [duration]);

  const handleTransitionEnd = () => {
    if (!visible) {
      onClose();
    }
  };

  return (
    <div
      className={`${styles.toast} ${visible ? styles.toastVisible : ''}`}
      onTransitionEnd={handleTransitionEnd}
    >
      {message}
    </div>
  );
};
